import React from 'react';
import displayName from 'component-lib/displayName';
import Icon from '../Icon';

import minusRedIcon from './images/minus-red.png';

export default function MinusRedIcon(props) {
    return <Icon image={minusRedIcon} {...props} />;
}

MinusRedIcon.displayName = displayName('Icons/MinusRedIcon');
